import React from 'react'
import { AvatarWithTextImage, AvatarWithTextInfo, AvatarWithTextWrapper } from './style'

const AvatarWithText = ({ name, position, photo, linkedin }: any) => (
  <AvatarWithTextWrapper>
    <div>
      <AvatarWithTextImage>
        {linkedin ? (
          <a target="_blank" href={linkedin}>
            <img src={photo} alt={name} />
          </a>
        ) : (
          <img src={photo} alt={name} />
        )}
      </AvatarWithTextImage>
      <AvatarWithTextInfo>
        {linkedin ? (
          <a target="_blank" href={linkedin}>
            <p className="name">{name}</p>
          </a>
        ) : (
          <p className="name">{name}</p>
        )}
        <p className="job">{position}</p>
      </AvatarWithTextInfo>
    </div>
  </AvatarWithTextWrapper>
)

export default AvatarWithText
